import { useState } from "react";

import { Textarea } from "shared/ui/shadcn/textarea";
import { Button } from "shared/ui/shadcn/button";
import { useIsNavigatorOnline } from "shared/lib/helpers/use-is-navigator-online";
import { CharacterLimitCounter } from "../../../user-input";

const DEFAULT_MAX_MESSAGE_LENGTH = 2000;

interface ChatInputProps {
  placeholder?: string;
  onSendMessage: (message: string) => void;
  bottomNote?: string;
  maxMessageLength?: number;
}

export const ChatInput = ({
  placeholder = "Write a message",
  onSendMessage,
  bottomNote,
  maxMessageLength = DEFAULT_MAX_MESSAGE_LENGTH,
}: ChatInputProps) => {
  const isOnline = useIsNavigatorOnline({
    showToasts: true,
  });
  const [message, setMessage] = useState("");

  const handleSend = () => {
    const trimmedMessage = message.trim();

    if (trimmedMessage) {
      onSendMessage(trimmedMessage);
      setMessage("");
    }
  };

  return (
    <div className="border-t bg-white p-4">
      <div className="relative">
        <Textarea
          disabled={!isOnline}
          className="max-h-[160px] min-h-[52px] pr-20"
          placeholder={placeholder}
          value={message}
          maxLength={maxMessageLength}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              handleSend();
            }
          }}
        />

        {isOnline && (
          <Button
            disabled={!message.trim()}
            type="submit"
            size="sm"
            className="absolute right-2 top-2"
            onClick={handleSend}
          >
            Send
          </Button>
        )}
      </div>

      <CharacterLimitCounter
        className="mt-2 text-gray-400"
        maxLength={maxMessageLength}
        contentLength={message.length}
      />

      {bottomNote && <p className="mt-2 text-xs text-gray-400">{bottomNote}</p>}
    </div>
  );
};
